export default __webpack_public_path__ + "static/media/signup.f4ccee57.PNG";